module.exports = __webpack_public_path__ + "static/media/jouvert.42d5c0e4.jpg";